const STORAGE_KEY = '@dm/navigation.switcherStorage';

const TIMEOUT = 5400000; // 90 minutes

// Returns a hash code for a string.
// (Compatible to Java's String.hashCode())
// https://gist.github.com/hyamamoto/fd435505d29ebfa3d9716fd2be8d42f0
//
// Need to hash sessionId so we don't leak session info out of the page.
function hashCode(s) {
	let h = 0,
		l = s.length,
		i = 0;
	if (l > 0) {
		while (i < l) {
			h = ((h << 5) - h + s.charCodeAt(i++)) | 0;
		}
	}
	return h;
}

function getStore() {
	let store;
	try {
		store = localStorage.getItem(STORAGE_KEY);
	} catch {}

	if (store) {
		// Prune all old (> 90 minutes) entries
		const result = JSON.parse(store);
		const minTimeout = new Date().getTime() - TIMEOUT;
		return Object.keys(result).reduce((acc, key) => {
			const entry = result[key];
			if (entry.timestamp > minTimeout) {
				acc[key] = result[key];
			}
			return acc;
		}, {});
	}
	return {};
}

function setStore(state) {
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
	} catch {}
}

function _save(sessionId, store, state) {
	store[hashCode(sessionId)] = {
		value: state,
		timestamp: new Date().getTime(),
	};

	setStore(store);
}

export function load(sessionId) {
	if (!sessionId) {
		// xapp routes
		return {
			isNew: false,
			isSwitcherHidden: true,
			isDefault: true,
		};
	}

	const store = getStore();
	const entry = store[hashCode(sessionId)];
	const state = entry
		? entry.value
		: {
				isNew: false,
				isSwitcherHidden: false,
				isDefault: true,
			};

	_save(sessionId, store, state); // refresh timestamp
	return state;
}

export function save(sessionId, state) {
	if (!sessionId) {
		return; // xapp routes
	}
	_save(sessionId, getStore(), state);
}
